import Vue from 'vue'
import App from './App'
import router from './router'

import store from "@/store/store";
import helpers from './helpers/helpers'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import * as jquery from 'jquery'
// import GoogleSignInButton from 'vue-google-signin-button-directive'
import GAuth from 'vue-google-oauth2'
import ThailandAutoComplete from 'vue-thailand-address-autocomplete'
import animateCss from "animate.css";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import VuejsClipper from 'vuejs-clipper'
import JsonExcel from 'vue-json-excel'


import Header from "./containers/TheHeader";
import Footer from './containers/TheFooter.vue'
import FooterMobile from './containers/TheFooterMobile.vue'

import VModal from 'vue-js-modal'

//socket io
// import VueSocketio from 'vue-socket.io-extended';
// import io from 'socket.io-client';
// Vue.use(VueSocketio, io('https://localhost:443/'));

const plugin = {
    install() {
        Vue.helpers = helpers
        Vue.prototype.$helpers = helpers
    }
}

// test for localhost: 553738419453-k89tphdnkkvb0crthf9havd83iq3k7k2.apps.googleusercontent.com
// for mdl server: 835114257224-crvo110a8lomvi0mngr95qgcknop641q.apps.googleusercontent.com
Vue.component('ThailandAutoComplete', ThailandAutoComplete)
Vue.component('Header', Header)
Vue.component('Footer', Footer)
Vue.component('FooterMobile', FooterMobile)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('downloadExcel', JsonExcel)
Vue.use(GAuth, { clientId: '835114257224-crvo110a8lomvi0mngr95qgcknop641q.apps.googleusercontent.com' })

Vue.config.performance = true
Vue.config.productionTip = false;
Vue.config.silent = true;

Vue.use(CoreuiVue)
Vue.use(plugin)
Vue.use(animateCss);
Vue.prototype.jquery = jquery
Vue.use(VuejsClipper, {
    components: {
        clipperUpload: true,
        clipperFixed: true,
        clipperPreview: true
    }
})

Vue.use(VModal)


Vue.directive('click-outside', {
    bind() {
        this.event = event => this.vm.$emit(this.expression, event)
        this.el.addEventListener('click', this.stopProp)
        document.body.addEventListener('click', this.event)
    },
    unbind() {
        this.el.removeEventListener('click', this.stopProp)
        document.body.removeEventListener('click', this.event)
    },

    stopProp(event) { event.stopPropagation() }
})


new Vue({
    el: '#app',
    router,
    store,
    icons,
    // GoogleSignInButton,
    template: '<App/>',
    components: {
        App
    },
})